import { iconSelector } from '../../utils/fileUtils';
import { FileViewerImage } from './FileViewer-style';

interface IOfficeViewer {
  fileUrl: string;
  fileType?: string;
}

const OfficeViewer: React.FC<IOfficeViewer> = ({ fileUrl, fileType }) => {
  if (fileUrl?.startsWith('http'))
    return (
      <iframe
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`}
        width="100%"
        height="100%"
        frameBorder="0"
      ></iframe>
    );
  else
    return (
      <FileViewerImage
        style={{ maxWidth: '100%', maxHeight: '100%', margin: '0 auto' }}
        src={iconSelector(fileType)}
      />
    );
  // return (
  //   <iframe
  //     src={`https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`}
  //     width="100%"
  //     height="100%"
  //   ></iframe>
  // );
};

export default OfficeViewer;
